module.exports = __webpack_public_path__ + "static/4-e1a350c388445277ea430602b8c915e3.jpeg";